import { useState, useEffect } from "react";
import t from "../translate";

const LinkButton = ({ onTap, value, actionValue, isConfirmVisible, onConfirm }) => {
  return (
    <div className="link-button">
      <img className="leading-icon" src="/assets/icons/ic_bookmark.svg" alt="ic_bookmark" />
      <h4 className="button-text" onClick={onTap}>
        {value}<strong>{actionValue}</strong>
      </h4>
      <div className="button-container">
        {isConfirmVisible ? (
          <button onClick={onConfirm} className="confirm-button">{t(localStorage.getItem('lang'), 'confirm')}</button>
        ) : (
          <img className="tale-icon" src="/assets/icons/ic_arrow_right.svg" alt="ic_arrow_right" />
        )}
      </div>
    </div>
  );
};

function loadAdSdkIfNotLoaded() {
  const scriptId = 'munqu-sdk';

  if (!document.getElementById(scriptId)) {
    const script = document.createElement('script');
    script.src = '//munqu.com/sdk.js';
    script.dataset.zone = '9248323';
    script.dataset.sdk = 'show_9248323';
    script.id = scriptId;
    script.async = true;

    script.onload = () => {
      console.log('Ad SDK loaded successfully.');
      // можливо викликати функцію ініціалізації, якщо така є
    };

    script.onerror = () => {
      console.warn('Ad SDK failed to load.');
    };

    document.body.appendChild(script);
  } else {
    console.log('Ad SDK already loaded.');
  }
}

// Викликаємо після певної події або з затримкою
window.addEventListener('load', () => {
  setTimeout(loadAdSdkIfNotLoaded, 1000); // затримка 1 секунда після завантаження сторінки
});


const TaskComponent = ({ task, onTaskRemove }) => {
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [confirmedTasks, setConfirmedTasks] = useState([]);

  useEffect(() => {

    const savedConfirmedTasks = JSON.parse(localStorage.getItem('confirmedTasks')) || [];
    setConfirmedTasks(savedConfirmedTasks);
  }, []);

  const handleLinkButtonClick = () => {
    const updatedConfirmedTasks = [...confirmedTasks, task.signature];
    setConfirmedTasks(updatedConfirmedTasks);
    localStorage.setItem('confirmedTasks', JSON.stringify(updatedConfirmedTasks));

    if (task.signature === 'redirect_task') {
      try {
        loadAdSdkIfNotLoaded();

        // eslint-disable-next-line no-undef
        show_9248323('pop').then(() => {
        }).catch(e => {
        })

      } catch (error) {

      }
    } else {
      window.open(task.link, '_blank', 'noopener,noreferrer');
    }

    setIsConfirmVisible(true);
  };

  const handleConfirmClick = (e) => {
    e.stopPropagation();

    console.log("Задача підтверджена");

    onTaskRemove(task.signature);

    const updatedConfirmedTasks = confirmedTasks.filter(id => id !== task.signature);
    setConfirmedTasks(updatedConfirmedTasks);
    localStorage.setItem('confirmedTasks', JSON.stringify(updatedConfirmedTasks));
    setIsConfirmVisible(false);
  };

  const isTaskConfirmed = confirmedTasks.includes(task.signature);

  useEffect(() => {
    if (isTaskConfirmed) {
      setIsConfirmVisible(true);
    }
  }, [isTaskConfirmed]);

  return (
    <div>
      <LinkButton
        onTap={handleLinkButtonClick}
        value={task.name}
        actionValue={task.actionValue}
        isConfirmVisible={isConfirmVisible}
        onConfirm={handleConfirmClick}
      />
    </div>
  );
};

export default TaskComponent;
